import { Map } from 'immutable';

/**
 * Convert target status list to keypair value list (name|value).
 *
 * @param statuses {Immutable.List} Target statuses from configuration.
 */
export default function targetStatuses(statuses) {
  return statuses.map(targetStatus =>
    Map({
      name: `${targetStatus.get('fc')} - ${targetStatus.get('d')}`,
      value: targetStatus.get('fc'),
      text: targetStatus.get('d'),
    }),
  );
}

/**
 * Get list of target status with blank default value.
 * Default value = { name: '', value: '', index: -1 }.
 *
 * @param {Immutable.List} statuses Target statuses from configuration{*} statuses.
 */
export function targetStatusesWithDefault(statuses) {
  const mappedStatuses = statuses.map((targetStatus, index) =>
    Map({
      index,
      name: `${targetStatus.get('fc')} - ${targetStatus.get('d')}`,
      value: targetStatus.get('fc'),
    }),
  );

  return mappedStatuses.insert(0, Map({ name: '', value: '', index: -1 }));
}
